export default __webpack_public_path__ + "static/media/pyposition_63a_big.95e9eaa0.png";